import React, { useState, memo } from 'react'
import { withTranslation } from 'react-i18next'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import {
  Box,
  Typography,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import useStyles from './stepperHorizontalStyle'
import { 
  PersonPinCircle as PinCircle,
  Check
} from '@material-ui/icons'
import moment from 'moment'

// Estilizando conectors do stepper
// https://mui.com/api/step-connector/

const RenderHorizontalStepper = ({ parent = true, history = null, horizontalValue = 0 }) => {
  const { t } = useTranslation();
  const size = useSelector((state) => state.preferences)
  let useStylesParams = {
    size: size,
  }
  const classes = useStyles(useStylesParams)
  let stepHorizontalValue = 0;
  if(history?.finished){
    stepHorizontalValue = 2;
  }else if(history?.progress){
    stepHorizontalValue = 1;
  }else if(history?.start){
    stepHorizontalValue = 0;
  }

  const theme = useTheme()

  let steps = [
    {
      nome: t('commons.start'),
      data: history?.start ? moment(history?.start).format('DD/MM/YYYY HH:mm:ss') : '',
    },
    {
      nome: t('commons.progress'),
      data: history?.progress ? moment(history?.progress).format('DD/MM/YYYY HH:mm:ss') : '',
    },
    {
      nome: t('commons.end'),
      data: history?.finished ? moment(history?.finished).format('DD/MM/YYYY HH:mm:ss') : '',
    },
  ]

  return (
    <div>
      <Box
        style={{ marginTop: '1em', fontSize: 18, marginBottom: '1em' }}
        sx={{ width: '100%' }}
      >
        <div className={classes.stepperNewParent}>
          <div className={classes.stepperNewIcon}>
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5em' }}>
                <PinCircle style={{
                  color: theme.palette.primary.main,
                  opacity: stepHorizontalValue === 0 ? 1 : 0 
                }}></PinCircle>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', textAlign:'center', alignItems:"center", marginBottom: '0.5em'}}>
              <PinCircle style={{
                color: theme.palette.primary.main,
                opacity: stepHorizontalValue === 1 ? 1 : 0 
              }}></PinCircle>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', textAlign:"end", marginBottom: '0.5em' }}>
              <PinCircle style={{
                color: theme.palette.primary.main,
                opacity: stepHorizontalValue === 2 ? 1 : 0 
              }}></PinCircle>
            </div>
          </div>
          <div className={classes.stepperNew}>
            <div style={{ flex: '0' }}>
              <div style={{
                    width: '24px',
                    height: '24px',
                    background: '#009EE2', 
                    borderRadius: '1em',
                    textAlign: 'center',
                    fontSize: '14px',
                    color:"#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                {stepHorizontalValue === 0 ? (
                  <p>1</p>
                ) : (
                  <Check style={{width:'16px', fill:"#172746"}}></Check>
                )}
              </div>
            </div>
            <div style={{ flex: '1' }}>

              {stepHorizontalValue > 0 ? (
              <span
                style={{
                  borderTopWidth: '3px',
                  borderTopStyle: 'solid',
                  borderColor: '#009EE2',
                  display: 'block',
                  width: '100%',
                }}
              ></span>
              ) : (
                <span
                style={{
                  borderTopWidth: '3px',
                  borderTopStyle: 'solid',
                  color: 'gray',
                  display: 'block',
                  width: '100%',
                }}
                ></span>
              )}
            </div>
            <div
              style={{ flex: '0', display: 'flex', justifyContent: 'center' }}
            >
              <div style={{
                    width: '24px',
                    height: '24px',
                    background: stepHorizontalValue < 1 ? 'gray' : '#009EE2',
                    borderRadius: '1em',
                    textAlign: 'center',
                    fontSize: '14px',
                    color:"#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                {stepHorizontalValue <= 1 ? (
                  <p>2</p>
                ) : (
                  <Check style={{width:'16px', fill:"#172746"}}></Check>
                )}
              </div>
            </div>
            <div style={{ flex: '1' }}>
            {stepHorizontalValue > 1 ? (
              <span
                style={{
                  borderTopWidth: '3px',
                  borderTopStyle: 'solid',
                  borderColor: '#009EE2',
                  display: 'block',
                  width: '100%',
                }}
              ></span>
              ) : (
                <span
                style={{
                  borderTopWidth: '3px',
                  borderTopStyle: 'solid',
                  color: 'gray',
                  display: 'block',
                  width: '100%',
                }}
                ></span>
              )}
            </div>
            <div
              style={{
                flex: '0',
                display: 'flex',
                justifyContent: 'end',
                position: 'relative',
                zIndex: 2,
              }}
            >
              <div style={{
                    width: '24px',
                    height: '24px',
                    background: stepHorizontalValue < 2 ? 'gray' : '#009EE2',
                    borderRadius: '1em',
                    textAlign: 'center',
                    fontSize: '14px',
                    color:"#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                {stepHorizontalValue < 2 ? (
                  <p>3</p>
                ) : (
                  <Check style={{width:'16px', fill:"#172746"}}></Check>
                )}
              </div>
            </div>
          </div>
            <div className={classes.stepperNewText}>
              {steps?.map((step, idx) => (
                <div style={{ 
                    textAlign: idx === 0 ? 'start' : idx === 1 ? 'center' : 'end',
                    margin: idx === 1 && '0 0.3em 0 0.3em',
                    width: '33%',
                    wordWrap: 'break-word',
                  }}
                  key={idx}
                  >
                  {idx <= stepHorizontalValue ? (
                  <div>
                    <Typography style={{fontWeight:"bold"}}>{steps[idx].nome}</Typography>
                    <Typography style={{fontWeight:"bold"}}>{steps[idx].data}</Typography>
                  </div>
                  ):(
                    <div>
                      <Typography>{steps[idx].nome}</Typography>
                      <Typography>{steps[idx].data}</Typography>
                    </div>
                  )}
              </div>

            ))}
            </div>
          </div>
      </Box>
    </div>
  )
}

export default withTranslation()(memo(RenderHorizontalStepper))
